/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import defaultAttributes from './defaultAttributes.js';
import { splitProps } from 'solid-js';
import h from 'solid-js/h';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const createSolidComponent = (iconName, iconNamePascal, iconNode) => {
  const Component = (props) => {
    const [localProps, rest] = splitProps(props, [
      "color",
      "size",
      "stroke",
      "children",
      "class"
    ]);
    const svgProps = __spreadProps(__spreadValues({}, defaultAttributes), {
      width: () => localProps.size != null ? localProps.size : defaultAttributes.width,
      height: () => localProps.size != null ? localProps.size : defaultAttributes.height,
      stroke: () => localProps.color != null ? localProps.color : defaultAttributes.stroke,
      "stroke-width": () => localProps.stroke != null ? localProps.stroke : defaultAttributes["stroke-width"],
      class: () => `tabler-icon tabler-icon-${iconName} ${localProps.class != null ? localProps.class : ""}`
    });
    return h(
      "svg",
      [svgProps, rest],
      [...iconNode.map(([tag, attrs]) => h(tag, attrs)), localProps.children]
    );
  };
  Component.displayName = `${iconNamePascal}`;
  return Component;
};

export { createSolidComponent as default };
//# sourceMappingURL=createSolidComponent.js.map
